export const ZAHL_STRING = '^[0-9]{0,65}$';
